import React from 'react';

import {
  LinkWithPulse,
  useByfunnPulseContext,
} from '../../../../../pulse/index.js';
import { console } from '../../../../../../core/system/console/console.server.js';
import { useRenderContext } from '../../../../contexts/RenderContext.js';

const openNativeMap = (
  latitude: number,
  longitude: number,
  heading?: string,
): boolean => {
  const payload = { latitude, longitude, heading };

  if (window.webkit?.messageHandlers.openMaps) {
    window.webkit.messageHandlers.openMaps.postMessage(payload);

    return true;
  }

  if (window.messageHandlers?.openMaps) {
    window.messageHandlers.openMaps.postMessage(JSON.stringify(payload));

    return true;
  }

  console.error('Missing iOS or Android handler for `openNativeMap`');

  return false;
};

type OpenMapButtonProps = React.PropsWithChildren<{
  latitude: number;
  longitude: number;
  locationName?: string;
  url?: string;
  className?: string;
}>;

const OpenMapButton: React.FC<OpenMapButtonProps> = ({
  latitude,
  longitude,
  locationName,
  url,
  className,
  children,
}) => {
  const { isHermesApp } = useRenderContext();
  const { trackClickUIElement } = useByfunnPulseContext();

  const href =
    url || `https://www.google.com/maps?q=${latitude},${longitude}&hl=no`;

  if (isHermesApp) {
    const handleClick = (): void => {
      trackClickUIElement(
        {
          object: {
            id: 'open-map-button',
            name: 'open map button',
            elementType: 'Button',
          },
        },
        {
          object: {
            objectId: 'open-map-button',
            name: 'open map button',
            elementType: 'Button',
          },
          placement: { containerName: 'page' },
        },
      );

      const success = openNativeMap(
        latitude,
        longitude,
        `Naviger til ${locationName || 'sted'}?`,
      );

      if (!success) {
        window.open(href, '_blank', 'noreferrer');
      }
    };

    return (
      <button className={className} onClick={handleClick}>
        {children}
      </button>
    );
  }

  return (
    <LinkWithPulse
      className={className}
      href={href}
      ariaLabel={`Åpne ${locationName || 'sted'} i Google Maps`}
      target="_blank"
      rel="noreferrer"
      objectId="open-map-button"
      name="open map button"
    >
      {children}
    </LinkWithPulse>
  );
};

export { OpenMapButton };
